enum HomeCardEventsEnum {
  PUBLISH = 'PUBLISH',
  PRIZE = 'PRIZE',
  COLLECT = 'COLLECT',
}
export default HomeCardEventsEnum;
